export default __webpack_public_path__ + "static/media/bg_hami.fc61ccf5.png";